const HelperSizeCheck = {
  checkSize: function (file) {
    const check = file.file.size / 1024 / 1024 <= 25;
    return check;
  },
};

export default HelperSizeCheck;
